import { type BaseProductElementProps } from "~/domains/product/types/BaseProductElementProps";
import { useProductContext } from "~/domains/product/ProductContext";
import { Translation } from "~/app/i18n/Translation";
import { styled, Typography, type TypographyProps } from "~/common/mui";

type Props = BaseProductElementProps &
  Omit<TypographyProps, "children"> & {
    truncate?: boolean;
  };

export const ShortDescriptionV2 = styled((props: Props) => {
  const product = useProductContext(props);

  return (
    <Typography {...props}>
      <Translation {...product.shortDescription} />
    </Typography>
  );
})(({ truncate }) => ({
  overflow: truncate ? "hidden" : undefined,
  textOverflow: truncate ? "ellipsis" : undefined,
  whiteSpace: truncate ? "nowrap" : undefined,
}));
